<template>
  <b-container fluid style="padding-bottom: 60px">
    <brands-filter :panel.sync="activePanel"
      :filter-active="(selBrands.length > 0 && selBrands.length < elevatorBrands.length) || (selModelTypes.length > 0 && selModelTypes.length < elevatorModelTypes.length)" :brands="elevatorBrands"
      :selected-brands.sync="selectedBrands" :model-types="elevatorModelTypes"
      :selected-model-types.sync="selectedModelTypes" name-prefix="outages" @invert="invertBrands()"
      @all="onBrandsAll()">
      <template #search>
        <clearable-input v-model="textFilter" placeholder="Filter..."></clearable-input>
      </template>
    </brands-filter>

    <b-row class="mt-3">
      <b-col>
        <h2>Breakdowns</h2>
      </b-col>
      <b-col cols="auto">
        <b-button variant="secondary" @click="$bvModal.show('outages-settings')">Settings</b-button>
      </b-col>
    </b-row>

    <b-modal id="outages-settings" title="Breakdown Settings" ok-title="Save" @ok="saveSettings">
      <b-form-group label="Threshold">
        <b-input-group append="seconds" style="width:200px">
          <b-form-input type="number" min="0" v-model.number="settingsOutageThreshold" placeholder="0 (immediate)" />
        </b-input-group>
      </b-form-group>
    </b-modal>

    <b-row align-v="center" v-if="filteredCurrentOutages.length > 0">
      <b-col class="mt-3">
        <h3>Current</h3>
        <b-table id="currentOutages" striped :items="filteredCurrentOutages" :fields="currentFields"
          @row-clicked="rowClickedHandler" :sort-by.sync="currentSortBy" :sort-desc.sync="currentSortDesc"
          @sort-changed="onCurrentSortChanged">
          <template #cell(name)="{ item }">
            <router-link :to="'/lifts/' + item.elevator_id" class="row-link">{{ elevatorName(item) }}</router-link>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row class="mt-3" v-if="filteredCurrentOutages.length > 0">
      <b-col>
        <h3>History</h3>
      </b-col>
    </b-row>
    <b-row align-v="center">
      <b-col sm="2">
        From: <date-picker :value="fromDate" @change="setFrom" />
      </b-col>
      <b-col sm="2">
        To: <date-picker :value="toDate" @change="setTo" />
      </b-col>
      <b-col cols="auto">
        Minimum duration:
        <b-input-group append="minutes" style="width:160px">
          <b-form-input type="number" min="0" v-model.number="minDuration"></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col>
        <b-button size="sm" class="mt-1" @click="setRange('today')">Today</b-button>
        <b-button size="sm" class="mt-1" @click="setRange('yesterday')">Yesterday</b-button>
        <b-button size="sm" class="mt-1" @click="setRange('thisWeek')">This Week</b-button>
        <b-button size="sm" class="mt-1" @click="setRange('lastWeek')">Last Week</b-button>
        <b-button size="sm" class="mt-1" @click="setRange('thisMonth')">This Month</b-button>
        <b-button size="sm" class="mt-1" @click="setRange('lastMonth')">Last Month</b-button>
        <b-button size="sm" class="mt-1" @click="setRange('thisYear')">This Year</b-button>
        <b-button size="sm" class="mt-1" @click="setRange('lastYear')">Last Year</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="mt-3">
        <b-table id="outages" striped :items="outages" :fields="fields" @row-clicked="rowClickedHandler"
          :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
          @sort-changed="onSortChanged" :busy="!loaded">
          <template #table-busy>
            <div class="text-center my-3">
              <b-spinner small /> Loading&hellip;
            </div>
          </template>
          <template #cell(name)="{ item }">
            <router-link :to="'/lifts/' + item.elevator_id" class="row-link">{{ elevatorName(item) }}</router-link>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row class="mt-2 align-items-center">
      <b-col cols="auto" v-if="outages.length > 15">
        <b-form-select v-model="perPage" :options="perPageOptions" style="width: auto"></b-form-select>
      </b-col>
      <b-col v-if="outages.length > perPage">
        <b-pagination v-model="currentPage" :total-rows="outages.length" :per-page="perPage" aria-controls="outages"
          class="mb-0"></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import api from './api.js'
import auth from './auth.js'
import moment from 'moment';
import formatter from './formatter.mixin.js';
import DatePicker from './DatePicker.vue'
import ClearableInput from './ClearableInput.vue'
import BrandsFilter from './BrandsFilter.vue'
import brandFilterMixin from './brandFilter.mixin.js'
export default {
  name: 'outages',
  props: ['elevators', 'settings'],
  mixins: [formatter, brandFilterMixin],
  components: { DatePicker, ClearableInput, BrandsFilter },
  data() {
    return {
      currentPage: 1,
      perPage: parseInt(localStorage.getItem('outagesPerPage')) || 15,
      perPageOptions: [
        { value: 15, text: '15' },
        { value: 30, text: '30' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
      ],
      loggedIn: auth.loggedIn(),
      loaded: false,
      outages: [],
      cachedElevatorTypes: [],
      localFrom: null,
      localTo: null,
      currentOutages: [],
      localTextFilter: (window.history.state && window.history.state.textFilter) || '',
      activePanel: null,
      minDuration: parseInt(localStorage.getItem('outageMinDuration') || '0', 10),
      outageThreshold: 0,
      settingsOutageThreshold: 0,
      currentSortBy: localStorage.getItem('currentOutagesSortBy') || 'started_at',
      currentSortDesc: localStorage.getItem('currentOutagesSortDesc') === 'true',
      sortBy: localStorage.getItem('outagesSortBy') || 'started_at',
      sortDesc: localStorage.getItem('outagesSortDesc') === 'true',
      currentFields: [
        {
          key: 'name',
          sortable: true,
          label: 'Lift',
          formatter: (value, key, item) => this.elevatorName(item),
        },
        {
          key: 'started_at',
          sortable: true,
          formatter: (value, key, item) => {
            return this.outageTimeFormatter(value);
          },
        },
        {
          key: 'position',
          sortable: true,
          label: 'Position',
        },
        {
          key: 'msg',
          sortable: true,
          label: 'Fault',
          formatter: (value, key, item) => {
            return value;
          },
        },
      ],
      fields: [
        {
          key: 'name',
          sortable: true,
          label: 'Lift',
          formatter: (value, key, item) => this.elevatorName(item),
        },
        {
          key: 'started_at',
          sortable: true,
          label: 'Time',
          formatter: (value, key, item) => {
            return this.outageTimeFormatter(value);
          },
        },
        /*
        { 
          key: 'end',
          formatter: (value, key, item) => {
            return this.outageTimeFormatter(value);
          },
        },
        */
        {
          key: 'duration',
          sortable: true,
          formatter: (value, key, item) => {
            return this.outageDurationFormatter(value);
          },
        },
        {
          key: 'position',
          sortable: true,
          label: 'Position',
        },
        {
          key: 'msg',
          sortable: true,
          label: 'Fault',
          formatter: (value, key, item) => {
            return value;
          },
        },
      ],
    }
  },
  computed: {
    textFilter: {
      get() { return this.localTextFilter; },
      set(newFilter) {
        this.localTextFilter = newFilter;
        const state = Object.assign({}, window.history.state, { textFilter: newFilter });
        window.history.replaceState(state, '');
      },
    },
    fromDate() { return this.from ? moment(this.from).format('YYYY-MM-DD') : '' },
    toDate() { return this.to ? moment(this.to).format('YYYY-MM-DD') : '' },
    // Derived from loaded data for the checkbox UI — used by filteredCurrentOutages
    // and to populate the brand/model checkboxes.
    elevatorBrands() {
      return [...new Set((this.elevators || []).map(e => this.elevatorBrandFormatter(e.type)))].filter(Boolean).sort();
    },
    elevatorModelTypes() {
      return [...new Set((this.elevators || [])
        .filter(e => this.selectedBrands.includes(this.elevatorBrandFormatter(e.type)))
        .map(e => this.elevatorTypeFormatter(e.type) || 'Other'))].filter(Boolean).sort();
    },
    selectedBrands: {
      get() { return this.selBrands.length > 0 ? this.selBrands : this.elevatorBrands },
      set(v) {
        const effective = v.length < this.elevatorBrands.length ? v : []
        if (effective.length === 0 && this.selBrands.length === 0) return
        this.selBrands = effective
        this.selModelTypes = []
      },
    },
    selectedModelTypes: {
      get() { return this.selModelTypes.length > 0 ? this.selModelTypes : this.elevatorModelTypes },
      set(v) {
        const effective = v.length < this.elevatorModelTypes.length ? v : []
        if (effective.length === 0 && this.selModelTypes.length === 0) return
        this.selModelTypes = effective
      },
    },
    // Resolve the selected brand+model filters to raw elevator_type keys so they
    // can be sent as server-side filter params.
    selectedElevatorTypes() {
      if (this.selBrands.length === 0 && this.selModelTypes.length === 0) return [];
      return Object.keys(this.ElevatorTypes).filter(rawType => {
        const brand = this.elevatorBrandFormatter(rawType);
        if (!this.selectedBrands.includes(brand)) return false;
        const model = this.elevatorTypeFormatter(rawType) || 'Other';
        return this.selectedModelTypes.includes(model);
      });
    },
    // Current (live) outages are not paginated so still filtered client-side.
    filteredCurrentOutages() {
      const q = this.textFilter.toLowerCase();
      return this.currentOutages
        .filter(o => {
          if (this.selBrands.length === 0) return true;
          return this.selBrands.includes(this.elevatorBrandFormatter(o.elevator_type));
        })
        .filter(o => {
          if (this.selModelTypes.length === 0) return true;
          const mt = this.elevatorTypeFormatter(o.elevator_type) || 'Other';
          return this.selModelTypes.includes(mt);
        })
        .filter(o => !q || (o.name && o.name.toLowerCase().includes(q)) || (o.host && o.host.toLowerCase().includes(q)) || (o.msg && o.msg.toLowerCase().includes(q)));
    },
    from: {
      get() { return this.localFrom; },
      set(v) { this.localFrom = v; }
    },
    to: {
      get() { return this.localTo; },
      set(v) { this.localTo = v; }
    },
  },
  watch: {
    settings: {
      immediate: true,
      handler(v) {
        const ot = parseInt(v && v.outage_threshold)
        if (!isNaN(ot)) {
          this.outageThreshold = ot
          this.settingsOutageThreshold = ot
        }
      },
    },
    minDuration(val) {
      if (val > 0) {
        localStorage.setItem('outageMinDuration', val);
      } else {
        localStorage.removeItem('outageMinDuration');
      }
      clearTimeout(this._minDurationTimer);
      this._minDurationTimer = setTimeout(() => this.reloadOutages(), 500);
    },
    // Filter changes must re-fetch from the server so the full timeframe is covered.
    selBrands() { if (this._initialized) this.reloadOutages(); },
    selModelTypes() { if (this._initialized) this.reloadOutages(); },
    localTextFilter() {
      if (!this._initialized) return;
      clearTimeout(this._textFilterTimer);
      this._textFilterTimer = setTimeout(() => this.reloadOutages(), 500);
    },
    currentPage() { },
    perPage(v) { localStorage.setItem('outagesPerPage', String(v)); this.currentPage = 1; },
  },
  methods: {
    saveSettings() {
      this.outageThreshold = this.settingsOutageThreshold;
      api.putSettings({ outage_threshold: String(this.settingsOutageThreshold) }, () => {
        this.reloadOutages();
      });
    },
    setFrom(v) {
      this.from = v ? moment(v).startOf('day').format() : null;
      this.reloadOutages();
    },
    setTo(v) {
      this.to = v ? moment(v).endOf('day').format() : null;
      this.reloadOutages();
    },
    onCurrentSortChanged({ sortBy, sortDesc }) {
      this.currentSortBy = sortBy;
      this.currentSortDesc = sortDesc;
      localStorage.setItem('currentOutagesSortBy', sortBy);
      localStorage.setItem('currentOutagesSortDesc', sortDesc);
    },
    onSortChanged({ sortBy, sortDesc }) {
      this.sortBy = sortBy;
      this.sortDesc = sortDesc;
      localStorage.setItem('outagesSortBy', sortBy);
      localStorage.setItem('outagesSortDesc', sortDesc);
    },
    prettyDate(date) {
      return moment(date).format('YYYY-MM-DD HH:mm');
    },
    dateFormatter(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    rowClickedHandler(record, index) {
      this.$router.push('/lifts/' + record.elevator_id)
    },
    getCurrentOutages() {
      api.getCurrentOutages(resp => {
        if (resp.data) {
          this.currentOutages = resp.data;
        } else {
          this.currentOutages = [];
        }
      });
    },
    handleOutageUpdate(outage) {
      const ended = !!outage.ended_at;
      const idx = this.currentOutages.findIndex(o => o.id === outage.id);
      if (!ended) {
        if (idx === -1) {
          this.currentOutages = [outage, ...this.currentOutages];
        } else {
          this.$set(this.currentOutages, idx, Object.assign({}, this.currentOutages[idx], outage));
        }
        if (outage.elevator_type && !this.cachedElevatorTypes.includes(outage.elevator_type)) {
          this.cachedElevatorTypes = [...this.cachedElevatorTypes, outage.elevator_type];
        }
      } else {
        if (idx !== -1) {
          this.currentOutages = this.currentOutages.filter(o => o.id !== outage.id);
        }
        // Insert the now-ended outage into the historical list if it falls in range,
        // rather than re-fetching everything.
        const startedAt = new Date(outage.started_at);
        const from = this.from ? new Date(this.from) : null;
        const to = this.to ? new Date(this.to) : null;
        if ((!from || startedAt >= from) && (!to || startedAt <= to)) {
          // Only insert if it matches the active server-side filters.
          const q = this.localTextFilter.toLowerCase();
          const matchesText = !q || (outage.name && outage.name.toLowerCase().includes(q)) || (outage.host && outage.host.toLowerCase().includes(q)) || (outage.msg && outage.msg.toLowerCase().includes(q));
          const selTypes = this.selectedElevatorTypes;
          const matchesType = selTypes.length === 0 || selTypes.includes(outage.elevator_type);
          if (matchesText && matchesType) {
            this.outages = [outage, ...this.outages];
          }
          if (outage.elevator_type && !this.cachedElevatorTypes.includes(outage.elevator_type)) {
            this.cachedElevatorTypes = [...this.cachedElevatorTypes, outage.elevator_type];
          }
        }
      }
    },
    connectOutagesWS() {
      this.$root.$on('elevator-outage', this.handleOutageUpdate);
    },
    reloadOutages() {
      this.currentPage = 1;
      this.getOutages();
    },
    getOutages() {
      const PAGE_SIZE = 1000;
      this.loaded = false;

      const fetchId = ++this._fetchId;
      const filters = {
        elevatorTypes: this.selectedElevatorTypes,
        text: this.localTextFilter,
      };

      const drain = (cursor, acc) => {
        api.getOutages(this.from, this.to, cursor, PAGE_SIZE, this.minDuration, filters, resp => {
          if (fetchId !== this._fetchId) return;
          if (!resp.data) { this.outages = acc; this.loaded = true; if (!this._initialized) this.$nextTick(() => { this._initialized = true; }); return; }
          const page = resp.data.data || [];
          const all = acc.concat(page);
          if (resp.data.has_more && resp.data.next_cursor) {
            drain(resp.data.next_cursor, all);
          } else {
            this.outages = all;
            // Accumulate elevator types into cache so checkboxes don't disappear when
            // a brand/model filter narrows the results.
            const newTypes = all.map(o => o.elevator_type);
            this.cachedElevatorTypes = [...new Set([...this.cachedElevatorTypes, ...newTypes])];
            this.loaded = true;
            if (!this._initialized) this.$nextTick(() => { this._initialized = true; });
          }
        });
      };

      drain(null, []);
    },
    setRange(range) {
      switch (range) {
        case 'today':
          this.from = moment().startOf('day').format();
          this.to = moment().endOf('day').format();
          break;
        case 'yesterday':
          this.from = moment().startOf('day').subtract(1, 'day').format();
          this.to = moment().endOf('day').subtract(1, 'day').format();
          break;
        case 'thisWeek':
          this.from = moment().startOf('week').format();
          this.to = moment().endOf('day').format();
          break;
        case 'lastWeek':
          this.from = moment().startOf('week').subtract(1, 'week').format();
          this.to = moment().endOf('week').subtract(1, 'week').format();
          break;
        case 'thisMonth':
          this.from = moment().startOf('month').format();
          this.to = moment().endOf('day').format();
          break;
        case 'lastMonth':
          this.from = moment().startOf('month').subtract(1, 'month').format();
          this.to = moment().subtract(1, 'month').endOf('month').format();
          break;
        case 'thisYear':
          this.from = moment().startOf('year').format();
          this.to = moment().endOf('day').format();
          break;
        case 'lastYear':
          this.from = moment().startOf('year').subtract(1, 'year').format();
          this.to = moment().endOf('year').subtract(1, 'year').format();
          break;
        case 'all':
          this.from = null;
          this.to = null;
          break;
      }

      this.reloadOutages();
    },
  },
  beforeRouteLeave(to, from, next) {
    history.replaceState(Object.assign({}, history.state, { outagesFrom: this.from, outagesTo: this.to }), '');
    next();
  },
  created() {
    this._fetchId = 0;
    this._textFilterTimer = null;
    this._minDurationTimer = null;
    this._initialized = false;
    auth.onChange = loggedIn => {
      this.loggedIn = loggedIn;
    }
    const state = history.state || {};
    if (state.outagesFrom) {
      this.from = state.outagesFrom;
      this.to = state.outagesTo;
    } else {
      this.from = moment().startOf('day').format();
      this.to = moment().endOf('day').format();
    }
    this.getCurrentOutages();
    this.getOutages();
    this.connectOutagesWS();
  },
  beforeDestroy() {
    this.$root.$off('elevator-outage', this.handleOutageUpdate);
  },
}
</script>

<style>
#outages tr,
#currentOutages tr {
  cursor: pointer;
}

#outages .row-link,
#currentOutages .row-link {
  color: inherit;
  text-decoration: none;
}

.filter-panel {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.35s ease;
}

.filter-panel-open {
  max-height: 1000px;
}

.filter-panel-content {
  padding-left: 15px;
  padding-bottom: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/Outages.vue